import React from 'react';
import './HelpDialog.css';
import { ThemeSetup } from '../../themes/ThemeSetup';
import { HelpInfo, HelpData, HelpLinkInfo } from '../../autogenerated/ZoomBridge';
import HelpUtil, { HelpType, IconPosition } from '../../util/HelpUtil';
import Draggable from 'react-draggable';
import ToolTip from '../AssetPropertyView';

/**
 * 
 * @param {{helpInfo: HelpInfo, helpItems: Array<HelpInfo>, onCloseDialog: Function, onHelpTypeText: Function}} param0 
 * @returns 
 */
function HelpDialog({ helpInfo, helpItems, onCloseDialog, onChildItemClick: onHelpTypeText }:
  { helpInfo: HelpInfo, helpItems: Array<HelpInfo>, onCloseDialog: Function, onChildItemClick: Function }) {

  /**
   * 
   * @param {String} linkUrl 
   */
  const handleOpenLink = (linkUrl) => {
    try {
      window.open(linkUrl);
    } catch (err) {
      console.log("Error while opening page : ", err ? err.toString() : "Unknown Error");
      window.setError(err);
    }
  };

  /**
   * 
   * @param {HelpInfo} helpItem 
   */
  const handleMenuClick = (helpItem: HelpInfo) => {
    let type = HelpUtil.getHelpType(helpItem, true);
    type === HelpType.TEXT ? onHelpTypeText(helpItem) : handleOpenLink(HelpUtil.getHelpUrlForChild(helpItem));
  };

  const renderHelpItems = (helpItem: HelpInfo, index: Number) => {
    const icon = HelpUtil.getHelpIcon(helpItem.getIconType());
    return (
      <div key={"help-item-" + index} className='help-menu-item-container' onClick={(event) => { handleMenuClick(helpItem); }}>
        <li className='help-menu-item'>
          <img className="help-menu-icon left-icon"
            src={icon} />
          <div className='help-menu-item-label'> {helpItem.getHelpHeader()} </div>
        </li>
      </div>
    );
  }

  const renderLinkItem = (linkItem: HelpLinkInfo, index: Number) => {
    const link_icon = HelpUtil.getHelpIcon(linkItem.getLinkIcon(), true);
    return (
      <div key={"help-link-" + index} className="help-footer-link">
        {
          linkItem.getIconPosition() == IconPosition.LEFT ?
            <img className="help-footer-icon left-icon"
              src={link_icon}
            /> : null
        }
        <div className="help-footer-link-label"
          onClick={() => { handleOpenLink(HelpUtil.getHelpUrlForLink(linkItem)); }}>
          {linkItem.getLinkLabel()}
        </div>
        {
          linkItem.getIconPosition() == IconPosition.RIGHT ?
            <img
              className="help-footer-icon right-icon"
              src={link_icon}
            /> : null
        }
      </div>
    );
  }

  return (
    <div className="help-dialog-container" name="Help-Dialog">
      <div className="help-header-container">
        <label className='help-header-label'>{HelpUtil.getHelpHeader(helpInfo)}</label>
        <img className="help-close-icon"
          src={ThemeSetup.getImageURL('help/cross-icon.svg')}
          onClick={onCloseDialog}
        />
      </div>
      <div className="help-dialog-body-container">
        <div className='help-dialog-body'
          onClick={(e) => { e.stopPropagation(); }}>
          {
            HelpUtil.isHelpInfoNotEmpty(helpInfo) ?
              <div className='help-dialog-content'>
                {helpInfo.getHelpContent()}
              </div> : null
          }
          {
            HelpUtil.isHelpItemsNotEmpty(helpItems) ?
              helpItems.map((helpItem, index) => {
                return renderHelpItems(helpItem, index);
              }) : null
          }
        </div>
        {
          helpInfo.getHelpLinks() && helpInfo.getHelpLinks().length ?
            (
              <div onClick={(e) => { e.stopPropagation(); }}>
                <hr className="help-divider" />
                <div className="help-dialog-footer">
                  {
                    helpInfo.getHelpLinks().map((helpLinkItem, index) => {
                      return renderLinkItem(helpLinkItem, index);
                    })
                  }
                </div>
              </div>
            ) : null
        }
      </div>
    </div>
  );
}
export default HelpDialog;